<template>
  <el-dialog 
    v-model="isVisible" 
    class="order-test" 
    :title="title"
    @close="$emit('close')"
  >
    <div class="pt-7 pl-11 pb-6 pr-6 content break-normal">

      <p>{{ $t("OrderPage[\"Shortcut { shortcutName } will be removed and is not recoverable.\"]", { shortcutName: shortcutName }) }} </p>
      <p>{{ $t("OrderPage[\"Do you want to proceed?\"]") }}</p>
      <div class="mt-9 flex justify-end">
        <el-button class="cancel-btn" @click="$emit('close')">{{ $t("OrderPage[\"Cancel\"]") }}</el-button>
        <el-button class="delete-btn" @click="$emit('delete')">{{ $t("OrderPage[\"Delete\"]") }}</el-button>
      </div>
    </div>
    
  </el-dialog>
</template>

<script>
export default {
  emits: ["close", "delete"],
  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    },
    shortcutName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isVisible: false
    }
  },
  computed: {
    title() {
      return `Delete Shortcut ${this.shortcutName}`;
    }
  },
  watch: {
    isShowDialog(newVal) {
      this.isVisible = newVal;
    }
  }  
}
</script>

<style scoped>
.content {
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #000000;
}
.cancel-btn {
  height: 42px;
  width: 140px;
  border: 1px solid #20A8C3;
  border-radius: 5px;
  color: #20A8C3;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.43px;
}

.cancel-btn:hover {
  background-color: #FFFFFF;
}

.delete-btn {
  height: 42px;
  width: 140px;
  border-radius: 5px;
  font-weight: 500;
  font-size: 15px;
  letter-spacing: 0.429px;
  color: #F15B2C;
  border-color: #F15B2C;
}
.delete-btn:hover {
  background-color: #FFFFFF;
}
</style>